export const GeolocationOutOfRangeError =
  "You are not in range to use this self check-in"
